import React from 'react'

const STATUS_STYLES: Record<string, { bg: string; color: string }> = {
    Active: { bg: '#ECFDF3', color: '#027A48' },
    Completed: { bg: '#ECFDF3', color: '#027A48' },
    Approved: { bg: '#ECFDF3', color: '#027A48' },
    Deactivated: { bg: '#F2F4F7', color: '#667085' },
    Rejected: { bg: '#FEF3F2', color: '#B42318' },
    Pending: { bg: '#FFFAEB', color: '#B54708' },
}

export function StatusTag({ status }: { status: string }) {
    const s = STATUS_STYLES[status] ?? { bg: '#F2F4F7', color: '#667085' }
    return (
        <span
            style={{
                display: 'inline-block',
                padding: '0.2rem 1rem',
                borderRadius: '9999px',
                fontSize: '1.3rem',
                fontWeight: 600,
                whiteSpace: 'nowrap',
                background: s.bg,
                color: s.color,
            }}
        >
            {status}
        </span>
    )
}

export default StatusTag